var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import Grid from 'syf-component-library/ui/patterns/Grid';
import styled from 'styled-components';
import { H2 } from 'syf-component-library/ui/typography';
import { t } from '../../../strings/i18n/i18n';
import { fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
var Heading = styled(H2)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  font-weight: ", ";\n  display: inline;\n"], ["\n  font-size: ", "px;\n  font-weight: ", ";\n  display: inline;\n"])), fontSizes.root, fontWeights.bold);
var SectionDescription = function (_a) {
    var sectionHeading = _a.sectionHeading, sectionDescription = _a.sectionDescription, size = _a.size, props = __rest(_a, ["sectionHeading", "sectionDescription", "size"]);
    return (_jsxs(Grid, __assign({ container: true, direction: "column" }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsx(Stack, { size: "large" }) })), _jsxs(Grid, __assign({ item: true }, { children: [_jsx(Heading, __assign({}, props, { children: sectionHeading })), ' ', t('uploadDocuments.sectionOptional')] })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Stack, { size: "medium" }) })), _jsx(Grid, __assign({ item: true }, { children: sectionDescription })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Stack, { size: size || 'large' }) }))] })));
};
export default SectionDescription;
var templateObject_1;
//# sourceMappingURL=index.js.map